export enum Reason {
    PAGE_DID_NOT_LOAD = 'PAGE_DID_NOT_LOAD',
    DID_NOT_RECEIVE_CONFIRMATION_CODE = 'DID_NOT_RECEIVE_CONFIRMATION_CODE'
}
